import template from './collapsable.tpl';
import DomUtil from '@/core/utils/domUtil';
import {gsap} from 'gsap';
import styles from './collapsable.module.scss';
import dropdown from '@/assets/icons/dropdown-grey.svg?raw'

let collapseHandler, lock, last;

export default class Collapsible {

    private data: any;
    private template: string;
    private collapsibles!: NodeListOf<Element>;
    private element!: HTMLElement | null;
    private _target!: HTMLElement;

    constructor(data) {

        this.data = data;
        this.template = template({data: this.data, styles: styles, icon: dropdown});

        collapseHandler = event => this.expandCollapse(event);
    }

    init() {
        if (this.element) {
            this.collapsibles = this.element.querySelectorAll('div');
            for (let div of this.collapsibles) {
                div.addEventListener('click', collapseHandler);
            }
        }
    }

    destroy() {
        if (this.element && DomUtil.isDescendant(this._target, this.element)) {
            this._target.removeChild(this.element);
        }
        this.element = null;
    }

    expandCollapse(event) {

        let show, hide;
        let target = event.target;

        if (!lock && event.target.tagName !== 'A') {
            this.lock();

            if (event.target.nodeName === 'H2' || event.target.nodeName === 'P') target = target.parentElement;


            if (last) {
                DomUtil.addClass(last, 'collapsed');
                hide = last;
            }
            if (last !== target) {
                DomUtil.removeClass(target, 'collapsed');
                show = target;
                last = target;
            } else {
                last = null;
            }


            this.animate(show, hide, this.unlock);
        }
    }

    lock() {
        lock = true;
    }

    unlock() {
        lock = false;
    }

    animate(show, hide, callback) {

        let once = true;
        function callbackHellion() {
            if (once && typeof callback === 'function') callback();
            once = false;
        }

        function resetHeight(element) {
            element.style.height = '';
        }

        if (show) {
            gsap.from(show, 0.3, {height: 38, onComplete: callbackHellion});
            gsap.to(show.querySelectorAll('p')[0], 0.3, {autoAlpha: 1, delay: 0.3});
            gsap.to(document.querySelector('h2 > span > svg'), 0.3, {rotate: 180});
        }
        if (hide) {
            gsap.to(hide, 0.3, {height: 38, onComplete: () => {callbackHellion(); resetHeight(hide)}});
            gsap.to(hide.querySelectorAll('p')[0], 0.2, {autoAlpha: 0})
            gsap.to(document.querySelector('h2 > span > svg'), 0.3, {rotate: 180});
        }

    }

    appendTo(target) {

        this._target = target;
        this._target.innerHTML += this.template;

        this.element = this._target.lastElementChild as HTMLElement;
    }
}
